export default "__VITE_ASSET__oRUJFPVX__"